/**
 * Confezione regalo in pagina prodotto.
 *
 * PROBLEMA CHE RISOLVE
 * Aggiungendo lo stesso prodotto prima senza confezione e poi con, Shopify fondeva le due
 * aggiunte in un'unica riga (stessa variante, stesse proprieta'): il cliente si ritrovava
 * una riga da 2 con una sola confezione, senza modo di distinguere quale articolo incartare.
 *
 * COME
 * Con la spunta attiva iniettiamo nel form prodotto una proprieta' nascosta
 * (properties[_gift_box_split]) che rende la riga diversa da quella "liscia": Shopify non le
 * fonde piu' e otteniamo due righe distinte dello stesso prodotto, una incartata e una no.
 * Subito dopo l'aggiunta agganciamo la confezione come riga annidata di quella nuova riga.
 *
 * Il biglietto e' una proprieta' della riga confezione ("Biglietto"), quindi e' per riga e
 * compare anche a checkout e in ordine. Nessuna modifica a product-form.js.
 */
(function () {
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var SPLIT_PROP = '_gift_box_split';
  var NOTE_PROP = 'Biglietto';

  var currentVariantId = null;
  var busy = false;

  function ok(r) {
    if (!r.ok) {
      return r.json().catch(function () { return {}; }).then(function (b) {
        throw new Error(b.description || b.message || 'HTTP ' + r.status);
      });
    }
    return r.json();
  }
  function cartJson() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(ok);
  }
  function checkbox() { return document.querySelector('.gift-box-product__checkbox'); }
  function noteField() { return document.querySelector('.gift-box-product__note'); }
  function panelOf(cb) { return document.getElementById(cb.getAttribute('aria-controls') || ''); }
  function productForm() {
    return document.querySelector('product-form form[data-type="add-to-cart-form"]');
  }

  function parentKeyOf(line) {
    var pr = line.parent_relationship;
    if (!pr) return null;
    return pr.parent_key || (pr.parent && pr.parent.key) || null;
  }
  function giftChildOf(cart, parentKey, giftVariantId) {
    var found = null;
    cart.items.forEach(function (line) {
      if (parentKeyOf(line) === parentKey && String(line.variant_id) === String(giftVariantId)) found = line;
    });
    return found;
  }

  function changeLine(key, quantity, properties) {
    var body = { id: key, quantity: quantity };
    if (properties) body.properties = properties;
    return fetch('/cart/change.js', {
      method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body)
    }).then(ok);
  }
  function addLine(item) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [item] })
    }).then(ok);
  }

  function setPanel(cb, open) {
    var panel = panelOf(cb);
    cb.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
  }

  // La proprieta' nascosta viaggia nel form: e' cio' che tiene la copia incartata su una
  // riga separata. Senza, Shopify la fonderebbe con la riga liscia gia' presente.
  var splitSeq = 0;
  function syncFormProperty(on) {
    var form = productForm();
    if (!form) return;
    var input = form.querySelector('input[name="properties[' + SPLIT_PROP + ']"]');
    if (on && !input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + SPLIT_PROP + ']';
      // Valore diverso a ogni aggiunta: due copie incartate hanno proprieta' diverse e
      // Shopify non le fonde, altrimenti finirebbero su una riga sola con una confezione.
      input.value = String(Date.now()) + '-' + (++splitSeq);
      form.appendChild(input);
    } else if (!on && input) {
      input.parentNode.removeChild(input);
    }
  }

  function attachChild(parentKey, giftVariantId, message) {
    return cartJson().then(function (cart) {
      if (giftChildOf(cart, parentKey, giftVariantId)) return null;   // una sola per riga

      var props = { _gift_box_for: parentKey };
      if (message) props[NOTE_PROP] = message;

      return addLine({
        id: Number(giftVariantId), quantity: 1,
        parent_line_key: parentKey, properties: props
      }).then(function () {
        // Shopify puo' rispondere 200 senza annidare: la riga sciolta va tolta, altrimenti
        // il cliente si ritrova una confezione scollegata dal prodotto.
        return cartJson().then(function (after) {
          if (giftChildOf(after, parentKey, giftVariantId)) return null;
          var stray = after.items.filter(function (l) {
            return String(l.variant_id) === String(giftVariantId) &&
              !parentKeyOf(l) &&
              l.properties && l.properties._gift_box_for === parentKey;
          })[0];
          if (!stray) throw new Error('Shopify non ha annidato la riga');
          return changeLine(stray.key, 0).then(function () {
            throw new Error('Shopify non ha annidato la riga (aggiunta piatta, rimossa)');
          });
        });
      });
    });
  }

  // Riporta il blocco a riposo dopo un'aggiunta andata a buon fine.
  // NON rispecchia il carrello: la spunta vale SOLO per l'aggiunta in corso. Farle governare
  // anche cio' che e' gia' nel carrello creava un conflitto: togliendola per aggiungere una
  // copia senza confezione, si finiva per togliere la confezione (e il biglietto) alla copia
  // gia' aggiunta, e le due righe si ricompattavano.
  function reset() {
    var cb = checkbox();
    if (!cb) return Promise.resolve();
    cb.checked = false;
    setPanel(cb, false);
    syncFormProperty(false);
    var note = noteField();
    if (note) note.value = '';
    return Promise.resolve();
  }


  function guard(promise, cb) {
    busy = true;
    cb.disabled = true;
    return promise
      .catch(function (err) { console.error('Confezione regalo (pagina prodotto) — errore:', err); })
      .then(reset)
      .then(function () {
        busy = false;
        var live = checkbox();
        if (live) live.disabled = false;
      });
  }

  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb.classList || !cb.classList.contains('gift-box-product__checkbox')) return;
    if (busy) { cb.checked = !cb.checked; return; }

    var wanted = cb.checked;
    setPanel(cb, wanted);
    syncFormProperty(wanted);   // sola cosa che fa: armare o disarmare la prossima aggiunta
    if (wanted) {
      var ta = noteField();
      if (ta) ta.focus();
    }
  });


  function register() {
    var cb = checkbox();
    if (!cb) return;

    currentVariantId = cb.dataset.variantId;
    reset();

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      currentVariantId = variant.id;
    });

    // Aggiunta dal form prodotto: ora la riga padre esiste (ed e' separata grazie al
    // marcatore), quindi possiamo agganciarci la confezione.
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      var live = checkbox();
      if (!live || !live.checked) return;

      var data = event.cartData || {};
      var added = data.items && data.items.length ? data.items[0] : data;
      if (!added || !added.key) return;

      var ta = noteField();
      guard(attachChild(added.key, live.dataset.giftBoxVariant, ta ? ta.value.trim() : ''), live);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', register);
  } else {
    register();
  }
})();
